

class poolSend {
    constructor() {
        this.task = [];
        this.isRunning = false;
        this.thread = 6;
    }
    addTasks(promiseArr) {
        this.task.push(...promiseArr);
        this._run();
    }
    async _run() {
        if (this.isRunning) {
            return;
        }
        this.isRunning = true;
        console.log("quick search start ....");
        try {
            let index = 0;
            let ps = [];
            while (index < this.thread && this.task.length > 0) {
                index++;
                ps.push(this._runThread());
            }
            await Promise.allSettled(ps);
        } finally {
            this.isRunning = false;
            console.log("quick search end ....")
        }
    }
    async _runThread() {
        if (this.task.length == 0) {
            return;
        }
        let fn = this.task.shift();
        if (!fn) {
            return;
        }
        return  Promise.resolve(fn()).finally(() => {
            return this._runThread();
        });
    }
}



export default new poolSend();


